import { Button } from '@/components/_untitled/base/buttons/button';
import { ArrowRight, Stars02 } from '@untitledui/icons';
import type { KycStepProps } from '../../config/kycSteps.config';
import { prefixes, useTypedTranslation } from "@/locales";

export function SuccessStep({ data, onComplete }: KycStepProps) {
    const [tSuccess] = useTypedTranslation(prefixes('kyc.steps.success'));

    const bidderNumber = data.bidderNumber
        ? String(data.bidderNumber).padStart(3, '0')
        : '467';

    return (
        <div className="flex flex-col items-center gap-6 p-4 mt-6">
            {/* Bidder number card with decorative elements */ }
            <div className="relative">
                {/* Decorative sparkles around card */ }
                <Stars02 className="absolute -top-2 -start-6 h-6 w-6 text-warning-400" />
                <Stars02 className="absolute top-6 -end-4 h-4 w-4 text-warning-400" />

                {/* Bidder number card */ }
                <div className="relative flex flex-col items-center justify-between rounded-xl border-t-4 border-warning-400 bg-gray-100 px-10 pb-0 pt-9 shadow-md">
                    {/* Sparkle inside card */ }
                    <Stars02 className="mb-6 h-6 w-6 shrink-0 text-warning-400" />

                    {/* Number content */ }
                    <div className="mb-10 flex flex-col items-center gap-0.5 text-center">
                        <p className="text-xs font-medium uppercase tracking-widest text-gray-400">
                            { tSuccess('bidderNumberLabel') }
                        </p>
                        <div className="text-5xl font-bold leading-8 tracking-tight text-gray-900">
                            { bidderNumber }
                        </div>
                    </div>

                    {/* Card bottom tab */ }
                    <div className="h-10 w-7 shrink-0 rounded-t-[36px] bg-gray-300" />
                </div>
            </div>

            {/* Greeting and description */ }
            <header className="flex flex-col text-center gap-1">
                <h2 className="text-3xl font-normal text-gray-900">
                    { tSuccess('greeting', { bidderNumber }) }
                </h2>
                <p className="text-md text-gray-600">
                    { tSuccess('description') }
                </p>
            </header>

            <div className="h-px w-full bg-gray-200" />
            {/* Action button */ }

            <div className="w-full px-4 py-2">
                <Button
                    color="primary"
                    size="lg"
                    onClick={() => onComplete()}
                    iconTrailing={ <ArrowRight className="rtl:rotate-180" size={ 20 }/> }
                    className="w-full bg-brand-950 hover:bg-brand-800 text-white"
                >
                    { tSuccess('startBidding') }
                </Button>
            </div>
        </div>
    );
}
